export const GetCalculateAge = (dob) => {
    if (!dob) return 'N/A';
  
    const birthDate = dob.toDate ? dob.toDate() : new Date(dob);
    if (isNaN(birthDate)) return 'N/A';
  
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
  
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
  
    return `${age} `;
  };
  